/**
 * Canonicalise the single login identifier field.
 *
 * The backend still names the JSON key ``email`` (USERNAME_FIELD), but the
 * value may be an email, a username, or a phone number.
 */

export function looksLikeEmail(value) {
  const text = String(value || '').trim();
  if (!text.includes('@') || text.includes(' ')) return false;
  const at = text.indexOf('@');
  const local = text.slice(0, at);
  const domain = text.slice(at + 1);
  return Boolean(local) && domain.includes('.');
}

export function looksLikePhone(value) {
  const text = String(value || '').trim();
  if (!text || text.includes('@')) return false;
  const digits = text.replace(/\D/g, '');
  if (digits.length < 7) return false;
  const leftover = text.replace(/[\s\-().+/]/g, '');
  return /^\d+$/.test(leftover);
}

export function canonicalizeLoginIdentifier(value) {
  const text = String(value || '').trim();
  if (!text) return '';
  if (looksLikeEmail(text)) return text.toLowerCase();
  return text;
}
